import React, { useCallback, useEffect, useRef } from "react";
import SunEditor from "suneditor-react";

type DoctorNoteTextEditorProps = {
  key?: any;
  content: string;
  name: string;
  disable: boolean;
  onChange: (_event: any, data: any) => void;
};

export const DEFAULT_DOCTOR_NOTE_TOOLBAR_BTNS = [
  ["formatBlock"],
  ["blockquote"],
  ["bold", "underline", "italic", "strike"],
  ["fontColor", "hiliteColor"],
  ["align", "list"],
  ["outdent", "indent"],
  ["removeFormat"],
];

const DoctorNoteTextEditor = (props: DoctorNoteTextEditorProps) => {
  // const editorRef = useRef<any>(null);

  const handleChange = useCallback(
    (content: string) => {
      let contentCheck = content;

      if (content === "<div><br></div>") {
        contentCheck = "";
      }

      props.onChange(null, { name: props.name, value: contentCheck });
    },
    [props.name, props.onChange]
  );

  // useEffect(() => {
  //   if (editorRef.current && props.content !== editorRef.current.getContents()) {
  //     editorRef.current.setContents(props.content);
  //   }
  // }, [props.content]);

  // const handleResizeEditor = (height: any, prevHeight: any) => {
  //   console.log("[DoctorNoteTextEditor] handleResize Check", { height, prevHeight });
  // };

  return (
    <SunEditor
      // config
      // getSunEditorInstance={(editor) => (editorRef.current = editor)}
      key={props.key ?? "DoctorNoteTextEditor"}
      height="calc(90vh - 25rem)"
      autoFocus={false}
      disable={props.disable}
      setOptions={{
        defaultTag: "div",
        showPathLabel: false,
        buttonList: DEFAULT_DOCTOR_NOTE_TOOLBAR_BTNS,
      }}
      // data
      setContents={props.content}
      // callback
      onChange={handleChange}
      // onResizeEditor={handleResizeEditor}
    />
  );
};

export default DoctorNoteTextEditor;
